// @flow
import * as React from 'react'
import Flex from 'ui/atoms/Flex'
import Space from 'ui/atoms/Space'
import Text from 'ui/atoms/Text'
import { CalendarIcon } from 'ui/Icons'

type Props = {
  center?: boolean,
  duration: ?number,
  noIcon?: boolean,
  timeslot: ?Date,
  withFooter?: boolean,
}

function getHumanReadableDateSlot(timeslot: ?Date) {
  if (!timeslot) return

  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }
  return timeslot.toLocaleDateString('en-US', options)
}

function getHumanReadableTimeSlot(timeslot: ?Date, duration: ?number) {
  if (!timeslot) return
  if (!duration) return

  const startTime = new Date(timeslot)
  const endTime = new Date(startTime)
  endTime.setMinutes(endTime.getMinutes() + duration)

  let options = { hour: 'numeric', minute: 'numeric' }

  let startTimeString = startTime.toLocaleTimeString('en-US', options)
  let endTimeString = endTime.toLocaleTimeString('en-US', {
    ...options,
    timeZoneName: 'short',
  })

  return `${startTimeString} - ${endTimeString}`
}

function TimeSlotDescription({
  center,
  duration,
  noIcon,
  timeslot,
  withFooter,
}: Props): React.Node {
  return (
    <div>
      <Flex align="start">
        <Space>
          <div className="mr-2 relative top-1">
            {!noIcon && <CalendarIcon />}
          </div>
          <div className={center ? 'text-center' : null}>
            <Text>{getHumanReadableDateSlot(timeslot)}</Text>
            <Text>{getHumanReadableTimeSlot(timeslot, duration)}</Text>
          </div>
          {withFooter && (
            <div className={center ? 'text-center' : null}>
              <Text>
                The patient will receive a confirmation email with a link to
                join the first visit at
                https://willow.doxy.me/schedulednewpatient.
              </Text>
            </div>
          )}
        </Space>
      </Flex>
    </div>
  )
}

export default TimeSlotDescription
